L.Control.BasemapsSwitcher = L.Control.extend({
    options: {
        position: 'topcenter',
    },

    initialize: function(layers, options){
        L.Util.setOptions(this, options);
        this.layers = layers
    },

    onAdd: function (map){
        const container = this.container = L.DomUtil.create('div', 'leaflet-control-basemapsSwitcher');

        // Disable mouse events propagation
        if (L.Browser.touch) {
          L.DomEvent.on(container, 'click', L.DomEvent.stopPropagation);
        } else {
          L.DomEvent.disableClickPropagation(container);
          L.DomEvent.on(container, 'wheel', L.DomEvent.stopPropagation);
        }

        this._createItems();
        // this._collapse();

        // container.addEventListener('mouseover', () => {
        //     this._expand();
        // })
        //
        // container.addEventListener('mouseout', () => {
        //     this._collapse();
        // })

        return container;
    },

    setActiveMap(baselayer) {
      this.container.childNodes.forEach((child, index) => {
        let check = child.querySelector('.check')
        if (this.layers[index].layer._leaflet_id !== baselayer._leaflet_id) {
          check.classList.remove('activeMap')
        } else {
          check.classList.add('activeMap')
        }
      })

      return true
    },

    _createItems() {

      this.layers.forEach( (obj, index) => {

          obj.id = index

          // Create control
          const imgContainer = L.DomUtil.create('div', 'basemapImg');
          const img = L.DomUtil.create('div');
          const name = L.DomUtil.create('div', 'name');
          const check = L.DomUtil.create('div', 'check');
          name.innerHTML = obj.name

          img.style.backgroundImage = `url(${obj.icon})`;
          imgContainer.append(img)
          img.append(check)
          img.append(name)

          imgContainer.addEventListener('click', () => {

            // First remove all layers except the required one
            this._removeLayers(obj.layer);

            // Switch to / add layer
            if(!(this._map.hasLayer(obj.layer))) {
              this._map.addLayer(obj.layer)
            }

            // Add check to icon
            check.classList.add('activeMap');

          })

          this.container.append(imgContainer)

      })
    },

    _removeLayers(layer){
        this.layers.forEach( (obj) => {
          if (obj.layer._leaflet_id !== layer._leaflet_id && this._map.hasLayer(obj.layer)) {
            this._map.removeLayer(obj.layer);
          }
        })
    },

    // _collapse(){
    //     this.container.childNodes.forEach( (child, index) => {
    //         if(this.layers[index].layer. !== this.activeMap.id){
    //             child.classList.add('hidden')
    //             let check = child.querySelector('.check')
    //             check.classList.remove('activeMap')
    //         }
    //     })
    //
    // },
    //
    // _expand(){
    //     this.container.childNodes.forEach( (child) => {
    //         child.classList.remove('hidden')
    //     })
    // }

})

L.BasemapsSwitcher = function(layers, options){
    return new L.Control.BasemapsSwitcher(layers, options);
}
